import React, { useState } from 'react';
import { Row, Col, Button,Form } from 'react-bootstrap';

export default function Registrar({handleChange,handleChangeInput,iniciarRegistro,nombres
  ,apellidos,telefono,correo,contraseña,termions,newsletter}) {  

  return (
    <>
      <Row>          
        <div className='text-center mb-4' style={{position:'relative'}}>
            <Button 
              variant="link" 
              className="text-decoration-none btn-nav-log"
              style={{
                position:'absolute'
                ,top:-7
                ,left:0
              }}
              onClick={()=>handleChange('')}
            >
            &lt; Atrás
          </Button>
          <div className="title-login">Registrarse</div>
        </div>
      </Row>
      <Form className="w-100" style={{ maxWidth: "400px" }}>
        <Row> 
          <Col xs={12} md={6}>
            <Form.Control type="text" placeholder="Ingresa tus nombres" className="fs-5 mb-3" 
              id='regNombres'            
              onChange={handleChangeInput}
              value={nombres}
            />
          </Col>
          <Col xs={12} md={6}>
            <Form.Control type="text" placeholder="Ingresa tus apellidos" className="fs-5 mb-3" 
              id='regApellidos'
              onChange={handleChangeInput}
              value={apellidos}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <Form.Control type="tel" placeholder="Ingresa tu teléfono" className="fs-5 mb-3"
              id='regTel'
              onChange={handleChangeInput}
              value={telefono}
            />
          </Col>
          <Col xs={12} md={6}>
            <Form.Control type="email" placeholder="Ingresa tu correo" className="fs-5 mb-3" 
              id='regEmail'
              onChange={handleChangeInput}
              value={correo}
            />
          </Col>
        </Row>
        <Form.Group className="mb-3">
          <Form.Control type="password" placeholder="Ingresa una contraseña" className="fs-5 mb-3" 
            id='regPassword'
            onChange={handleChangeInput}
            value={contraseña}
          />
        </Form.Group>
        <Form.Group className="mb-3 d-flex align-items-center">
          <Form.Check type="checkbox" className="me-2"
            id='regTerminos'
            onChange={handleChangeInput}
            value={termions}
          />
          <span>
            Al continuar acepto los términos del
            <a href="#" className="text-decoration-none btn-a-log border-bottom"> Aviso de privacidad</a>
          </span>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Check type="checkbox" label="Deseo recibir el Newsletter" 
            id='regNewsletter'
            onChange={handleChangeInput}
            value={newsletter}
          />
        </Form.Group>
        <Button variant="primary" className="w-100 mb-3 btns-primary"
          onClick={()=>iniciarRegistro()}
        >
          Registrarme
        </Button>
      </Form>


      <div className="text-center">
        <span className='btn-a-log'>¿Ya tienes una cuenta? </span>
        <a            
          href='#'
          className="text-decoration-none btn-a-log border-bottom fw-bold"
          onClick={()=>handleChange('login')} 
        >
            Iniciar sesión
        </a>
      </div>
    </>
  );
}